import { useState } from 'react';
import XenieLogoDark from "../../Assets/XenieLogoDark.png";
import { Link } from 'react-router-dom';
import { verifyEmail } from '../../lib/utils/utils';
import EmailGIF from '../../Assets/email-error.gif';
import { checkEmailOnForgotPassword } from '../../lib/utils/apiCalls';

function ForgotPassword() {
    const [error, setError] = useState('');

    const [email, setEmail] = useState('');

    const [requested, setRequested] = useState(false);

    const [invalidEmail, setInvalidEmail] = useState(false);

    const changeHandler = (e) => {
        setEmail(e.target.value);
    }

    const handleButtonClick = async (e) => {
        e.preventDefault();

        let tempError = '';

        if(!email.trim()) {
            tempError = 'Email is required';
        }
        else if(!verifyEmail(email.trim())) {
            tempError = 'Enter a valid email address';
        }

        if(invalidEmail) {
            setInvalidEmail(false);
        }

        if(!tempError.trim()) {
            setError('');
            const response = await checkEmailOnForgotPassword(email);
            if(response?.status === 200) {
                setRequested(true);
            }
            else {
                if(response?.data?.message === 'Seller not exits' || response?.response?.data?.message === 'Seller not exits') {
                    setError('This Email is not registered on our Database. Please check the Email address.');
                    setInvalidEmail(true);
                }
                else {
                    setError('An error occurred. Please try again later.');
                    if(invalidEmail) {
                        setInvalidEmail(false);
                    }
                }
            }
        }
        else {
            setError(tempError);
        }
    }

    return (
        <>
            {
                !requested ? 
                <div className='max-w-screen h-screen flex justify-center pb-16 overflow-y-scroll'>
                    <div className="mt-[112px] w-[44%] h-fit p-10 bg-[#FFFFFF] border border-[#EAEAEA] rounded-2xl flex flex-col items-center gap-20">
                        <div className="h-11 w-auto">
                            <img className='h-full w-auto mx-auto' src={XenieLogoDark} alt="" />
                        </div>

                        <div className="flex flex-col gap-6 w-full">
                            <div className="flex flex-col gap-6">
                                <div className="flex flex-col">
                                    <h1 className='font-semibold text-[32px] leading-[44px] text-[#121212]'>Forgot Password?</h1>

                                    <p className='font-medium text-base text-[#666666]'>Don&#39;t worry, we&#39;ll send you the reset instructions</p>
                                </div>

                                <div className="flex flex-col gap-8">
                                    <div className="flex flex-col gap-3">
                                        <label className='font-medium text-base text-[#121212]' htmlFor="email">Email Address</label>

                                        <input 
                                            className={`font-normal text-base text-[#121212] placeholder:text-[#666666] outline-none px-3 py-4 rounded-[9px] bg-[#F5F5F5] border ${error.trim() ? 'border-[#EF4444]' : 'border-[#EAEAEA]'}`} 
                                            placeholder='Enter your email address' 
                                            id='email' 
                                            type="email" 
                                            value={email} 
                                            onChange={changeHandler} 
                                        />

                                        {error && <p className='text-[14px] leading-5 text-[#DC2626]'>{error}</p>}
                                    </div>

                                    <button onClick={handleButtonClick} className={`outline-none font-semibold text-[18px] leading-6 ${invalidEmail ? 'bg-buttonDisabledBg' : 'bg-primaryColor hover:bg-primaryAccent'} text-buttonText rounded-[9px] px-3 py-4`}>
                                        {error.trim() ? 'Send Email' : 'Reset password'}
                                    </button>
                                </div>
                            </div>

                            <p className="font-medium text-[14px] leading-6 mx-auto text-[#000000]">Back to <Link className='font-semibold text-link hover:underline' to='/signin'>Sign-in</Link></p>
                        </div>
                    </div>
                </div> : 
                <div className='max-w-screen h-screen flex items-center justify-center pb-16 overflow-y-scroll'>
                    <div className="w-full px-6 h-[36px] fixed top-8 left-8">
                        <img
                            className="w-auto h-full scale-150 max-[1080px]:scale-125" 
                            src={XenieLogoDark}
                            alt="Xenie Logo"
                        />
                    </div>

                    <div className="w-[57%] h-fit p-10 border border-[#EAEAEA] rounded-2xl flex flex-col items-center">
                        <div className="w-[200px] h-[200px] flex items-center justify-center">
                            <img className='w-full h-full' src={EmailGIF} alt="" />
                        </div>

                        <div className="flex flex-col gap-6 items-center">
                            <h1 className='font-semibold text-[32px] leading-[44px] text-[#121212]'>Check your Inbox</h1>

                            <p className='font-medium text-base text-[#666666] text-center'>We've sent password reset instructions to your email. Please follow the steps in the email to reset your password. If you don't see the email, be sure to check your spam or junk folder.</p>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ForgotPassword;
